import React from "react";
import PropTypes from "prop-types";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import "./spinner.scss";

const Spinner = ({ small, nano, gray, ...props }) => (
  <AiOutlineLoading3Quarters
    {...props}
    className={`animate-spin m-auto ${
      // eslint-disable-next-line no-nested-ternary
      nano ? "text-base" : small ? "text-xl" : "text-5xl"
    } ${gray ? "text-gray-600" : "text-primary"}`}
  />
);

Spinner.propTypes = {
  small: PropTypes.bool,
  nano: PropTypes.bool,
  gray: PropTypes.bool
};

Spinner.defaultProps = {
  small: false,
  nano: false,
  gray: false
};

export default Spinner;
